<div class="portfolio-table">
  <div class="portfolio-table__container">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      class="mat-table"
      [matSortDisabled]="!enableSort"
    >
      <ng-container
        *ngFor="let column of displayedColumns"
        [matColumnDef]="column"
        [sticky]="enableSticky && columnConfigurations[column]?.isSticky"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          [class.hoverable-header]="enableHeaderMenu && columnConfigurations[column]?.hasHeaderMenu"
        >
          {{ columnConfigurations[column]?.displayName }}
          <header-menu
            *ngIf="enableHeaderMenu && columnConfigurations[column]?.hasHeaderMenu"
            [field]="column"
            [columnName]="column"
            [currentSortColumn]="currentSortColumn"
            [currentSortDirection]="currentSortDirection"
          ></header-menu>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="columnConfigurations[column]?.hasCustomContent; else defaultCell">
            <ng-container [ngSwitch]="true">
              <ng-container *ngSwitchCase="column === 'protocolNumber'">
                <a
                  [routerLink]="[routePrefix, 'study-details', element.studySk]"
                  cdkOverlayOrigin
                  #protocolOrigin="cdkOverlayOrigin"
                  (mouseenter)="onProtocolMouseEnter(element)"
                  (mouseleave)="onProtocolMouseLeave()"
                >
                  {{ element.protocolNumber !== 'NULL' ? element.protocolNumber : '' }}
                </a>

                <cds-tooltip
                  [origin]="protocolOrigin"
                  [open]="protocolTooltipElement === element && protocolTooltipOpen"
                  placement="right"
                  [panelWidth]="256"
                  [hasBackdrop]="false"
                  (hovered)="onProtocolTooltipHover()"
                  (unhovered)="onProtocolTooltipLeave()"
                >
                  <ng-template #tooltipContent>
                    <div class="portfolio-table__tooltip-header">
                      {{ element.protocolNumber }}
                    </div>
                    <div class="portfolio-table__tooltip-body">
                      {{ element.protocolDesc }}
                    </div>
                  </ng-template>
                </cds-tooltip>
              </ng-container>
              <ng-container *ngSwitchCase="column === 'country' && element[column] === 'Multiple'">
                <button
                  class="portfolio-table__country-tooltip-button"
                  type="button"
                  cdkOverlayOrigin
                  #countryOrigin="cdkOverlayOrigin"
                  (click)="toggleCountryTooltip(element)"
                  [class.portfolio-table__country-tooltip-button--active]="
                    countryTooltipElement === element
                  "
                >
                  Multiple
                </button>

                <cds-tooltip
                  [origin]="countryOrigin"
                  [open]="countryTooltipElement === element"
                  (openChange)="onCountryTooltipChange($any($event), element)"
                  [tooltipId]="'country-tooltip-' + element.studySk"
                  [hasBackdrop]="false"
                  [closeOnOutsideClick]="true"
                  [panelWidth]="256"
                >
                  <ng-template #tooltipContent>
                    <div class="portfolio-table__tooltip-header">
                      Countries: {{ element.countryList.length }}
                    </div>
                    <div class="portfolio-table__country-list">
                      <div *ngFor="let item of element.countryList">• {{ item }}</div>
                    </div>
                  </ng-template>
                </cds-tooltip>
              </ng-container>

              <ng-container
                *ngSwitchCase="column === 'ppdRegion' && element[column] === 'Multiple'"
              >
                <button
                  class="portfolio-table__country-tooltip-button"
                  type="button"
                  cdkOverlayOrigin
                  #ppdRegionOrigin="cdkOverlayOrigin"
                  (click)="togglePpdRegionTooltip(element)"
                  [class.portfolio-table__country-tooltip-button--active]="
                    ppdRegionTooltipElement === element
                  "
                >
                  Multiple
                </button>

                <cds-tooltip
                  [origin]="ppdRegionOrigin"
                  [open]="ppdRegionTooltipElement === element"
                  (openChange)="onPpdRegionTooltipChange($any($event), element)"
                  [tooltipId]="'ppd-region-tooltip-' + element.studySk"
                  [hasBackdrop]="false"
                  [closeOnOutsideClick]="true"
                  [panelWidth]="256"
                >
                  <ng-template #tooltipContent>
                    <div class="portfolio-table__tooltip-header">
                      Regions: {{ element.ppdRegionList.length }}
                    </div>
                    <div class="portfolio-table__country-list">
                      <div *ngFor="let item of element.ppdRegionList">• {{ item }}</div>
                    </div>
                  </ng-template>
                </cds-tooltip>
              </ng-container>
              <ng-container *ngSwitchCase="column === 'milestoneStatus'">
                <span
                  class="portfolio-table__milestone-tooltip-anchor"
                  cdkOverlayOrigin
                  #milestoneOrigin="cdkOverlayOrigin"
                  (mouseenter)="onMilestoneMouseEnter(element)"
                  (mouseleave)="onMilestoneMouseLeave()"
                >
                  <status-badge
                    [type]="'portfolioMilestone'"
                    [badgeKey]="element[column]"
                  ></status-badge>
                </span>

                <cds-tooltip
                  [origin]="milestoneOrigin"
                  [open]="
                    milestoneTooltipElement === element &&
                    milestoneTooltipOpen &&
                    shouldShowMilestoneTooltip(element)
                  "
                  placement="left"
                  [panelWidth]="310"
                  [hasBackdrop]="false"
                  (hovered)="onMilestoneTooltipHover()"
                  (unhovered)="onMilestoneTooltipLeave()"
                >
                  <ng-template #tooltipContent>
                    <div class="study-gantt-chart-tooltip-container">
                      <div class="study-gantt-chart-tooltip-title">
                        {{ getMilestoneTooltipTitle(element) }}
                      </div>
                      <div class="study-gantt-chart-tooltip-contents">
                        <div class="study-gantt-chart-tooltip-status-item">
                          <span class="study-gantt-chart-tooltip-label">Status:</span>
                          <status-badge
                            [type]="'portfolioMilestone'"
                            [badgeKey]="element.milestoneStatus"
                          ></status-badge>
                        </div>
                        <div class="study-gantt-chart-tooltip-item">
                          <span class="study-gantt-chart-tooltip-label">Date</span>
                          <span class="study-gantt-chart-tooltip-value">
                            Baseline:
                            {{ getMilestoneTooltipDate(element.milestoneDates?.values?.baseline) }}
                          </span>
                          <span class="study-gantt-chart-tooltip-value">
                            Planned:
                            {{ getMilestoneTooltipDate(element.milestoneDates?.values?.planned) }}
                          </span>
                          <span class="study-gantt-chart-tooltip-value">
                            Actual:
                            {{ getMilestoneTooltipDate(element.milestoneDates?.values?.actual) }}
                          </span>
                        </div>
                        <ng-container *ngIf="getMilestoneTooltipDeltaParts(element) as deltaParts">
                          <div class="study-gantt-chart-tooltip-item">
                            <span class="study-gantt-chart-tooltip-value">
                              <span class="study-gantt-chart-tooltip-highlight-value">
                                {{ deltaParts.bold }}
                              </span>
                              {{ deltaParts.regular }}
                            </span>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                </cds-tooltip>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ element[column] !== 'NULL' ? (element[column] ?? '') : '' }}
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-template #defaultCell>
            {{ element[column] !== 'NULL' ? (element[column] ?? '') : '' }}
          </ng-template>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
@if (!hasData) {
  <div class="portfolio-table__no-results">
    <no-results></no-results>
  </div>
}
